import { NEWSLETTER_BUNDLES } from "shared/data/newsletter";

export const getPackageNameFromNewsletterIds = (newsletterIds: string[]): string | undefined => {
  const newsletterIdSet = new Set(newsletterIds);

  for (const bundle of NEWSLETTER_BUNDLES) {
    const isSubset = bundle.newsletters.every(id => newsletterIdSet.has(id));
    if (isSubset) {
      return bundle.displayName;
    }
  }

  return undefined;
};
